module.exports = __webpack_public_path__ + "static/img/page_28.e3c03ba9.png";